//#region src/js/cart-drawer-items.js
var CartDrawerItems = class extends CartItems {
	getSectionsToRender() {
		return [{
			id: "CartDrawer",
			section: "cart-drawer",
			selector: "[data-cart-inner]"
		}, {
			id: "cart-icon-bubble",
			section: "cart-icon-bubble",
			selector: ".shopify-section"
		}];
	}
};
customElements.define("cart-drawer-items", CartDrawerItems);
//#endregion
